import { BaseElement, defineElement } from '@webtides/element-js';

/**
 * @property {string} name
 * @property {boolean} selected
 * @property {TabRegisterStore} tabRegisterStore
 */
export default class TabPanel extends BaseElement {
    constructor() {
        super({ propertyOptions: { selected: { reflect: true } } });
    }

    properties() {
        return {
            name: undefined,
            selected: false,
        };
    }

    injectProperties() {
        return {
            /** @type {TabRegisterStore} */
            tabRegisterStore: (tabRegisterStore) => {
                tabRegisterStore.register('panel', this);
            },
        };
    }

    connected() {
        // Accessibility
        this.setAttribute('role', 'tabpanel');
        this.setAttribute('id', `tab-panel-${this.name}`);
        this.setAttribute('aria-labelledby', `tab-link-${this.name}`);
    }

    afterUpdate() {
        // Accessibility
        this.toggleAttribute('hidden', !this.selected);
    }
}

defineElement('mb-tab-panel', TabPanel);
